<script lang="ts" context="module">
	
    import {readable, derived } from 'svelte/store'

    export const breakpoint = readable("l",(set)=>{
        const breakpoints = [
            { value: "xs", mediaquery: window.matchMedia("(max-width: 575.98px)") },
            { value: "sm", mediaquery: window.matchMedia("(min-width: 575.99px) and (max-width: 767.98px)") },
            { value: "md", mediaquery: window.matchMedia("(min-width: 767.99px) and (max-width: 991.98px)") },
            { value: "lg", mediaquery: window.matchMedia("(min-width: 991.99px) and (max-width: 1199.98px)") },
            { value: "xl", mediaquery: window.matchMedia("(min-width: 1199.99px) and (max-width: 1399.98px)") },
            { value: "xxl", mediaquery: window.matchMedia("(min-width: 1399.99px)") },
        ];

        for (let key in breakpoints) {
            let breakpoint = breakpoints[key];

            //set the current breakpoint
            if (breakpoint.mediaquery.matches === true) {
                // EventBus.$emit("breakpoint", breakpoint.value);
                set(breakpoint.value)
            }
            breakpoint.mediaquery.addEventListener('change',(event) => {
                if (event.matches === true) {
                    // EventBus.$emit("breakpoint", breakpoint.value);
                    set(breakpoint.value)
                }
            });
        }
    });

    export const platform = derived(breakpoint, $breakpoint => {
        if ($breakpoint == "xs" || $breakpoint == "s") {
            return 'mobile';
        } else {
            return 'desktop';
        }
    }); 
       
    export const orientation = readable("landscape",(set)=>{
        const orientations = [
            { value: "portrait", mediaquery: window.matchMedia("(orientation: portrait)") },
            { value: "landscape", mediaquery: window.matchMedia("(orientation: landscape)") },
        ];

        for (let key in orientations) {
            let orientation = orientations[key];

            //set the current orientation
            if (orientation.mediaquery.matches === true) {
                set(orientation.value)
            }

            orientation.mediaquery.addEventListener('change',(event) => {
                if (event.matches === true) {
                    set(orientation.value)
                }
            });
        }
    });


</script>